import Index from '@tunnel-components/@pages/lapi-tmd/explorer/container'

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/lapi-tmd/explorer/index.ts